import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 16 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 19\" id=\"icon-cart\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.687 4a2.312 2.312 0 1 1 4.625 0v.313H5.687V4ZM4.312 5.688V7a.687.687 0 1 0 1.375 0V5.687h4.625V7a.687.687 0 1 0 1.375 0V5.687h1.676l.895 11.625H1.742l.895-11.625h1.675Zm0-1.375V4a3.688 3.688 0 0 1 7.375 0v.313H14c.36 0 .658.276.685.634l1 13a.687.687 0 0 1-.685.74H1a.688.688 0 0 1-.685-.74l1-13A.687.687 0 0 1 2 4.312h2.312Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol